// extracted by mini-css-extract-plugin
module.exports = {"secondary":"#888","meta":"blog-page-module--meta--1Y53g"};